import React from "react";
import "./DealerLocationCard.scss";
import { MdContentCopy } from "react-icons/md";
import { lightBlue } from "styles/colors.module.scss";
import DealerLocationService from "services/DealerLocationService";

function DealerLocationCard(props) {
  const { dealerLocation } = props;

  const copyMessageToActiveConversation = () => {
    const locationMessage = {
      latitude: dealerLocation.latitude,
      longitude: dealerLocation.longitude,
      address: dealerLocation.address,
      locationName: dealerLocation.dealerName,
      messageToCopyToChatTextArea:
        dealerLocation.dealerName + "\n" + dealerLocation.address,
    };
    DealerLocationService.copyDealerLocation(locationMessage);
  };

  const dealerDistance = `${dealerLocation.distanceInMeters / 1000} km`;

  return (
    <div className="dealer-location-card">
      <div className="name-and-distance">
        <div className="dealer-name">{dealerLocation.dealerName}</div>
        <div className="distance">{dealerDistance}</div>
      </div>
      <div className="dealer-address">{dealerLocation.address}</div>
      <div className="copy-div">
        <MdContentCopy
          className="copy-msg-icon"
          color={lightBlue}
          size="15"
          onClick={copyMessageToActiveConversation}
        />
      </div>
    </div>
  );
}

export default DealerLocationCard;
